<template>
<div>
    <input type="file" id="attachment" class="border rounded" ref="attachment" v-on:change="upload()">
</div>
</template>

<script>
    export default {
        props: {
            url: {default:''}
        },
        data: function() {
            return {
                attachments: []
            }
        },
        methods: {
            upload() {
                let attachment = this.$refs.attachment.files
                for (let i = 0; i < attachment.length; i++) {
                    const file = attachment[i]
                    console.log(this.url)
                    let formData = new FormData()
                    formData.append('attachment', file)

                    window.axios.post(
                        this.url,
                        formData,
                        {headers:{'Content-Type':'multipart/form-data'}}
                    ).then((response)=>{
                        this.$emit('change',true)
                    }).catch((error)=>{
                        console.log(error)
                    }).then(()=>{
                        this.$refs.attachment.value = ''
                    })



                    // console.log(file)
                    
                }
            }
        },
        beforeCreate() {
        },
        mounted() {
        }
    }
</script>
